// eslint-disable-next-line no-restricted-imports
import FlowScreens from 'core/common/components/FlowScreens';
import { FlowScreens as RedesignFlowScreens } from 'core/common/ui/pages';
import { FlowProvider, FunnelProvider } from 'core/funnel/contexts';
import { FunnelConfig } from 'core/funnel/entities';
import { useFunnelConfig } from 'core/funnel/hooks';

type DraftFlowProps = {
  screenId: string;
  isRedesignFlow?: boolean;
  funnelConfig: FunnelConfig;
};

export const DraftFlow = ({ isRedesignFlow = false, funnelConfig, screenId }: DraftFlowProps) => {
  const { config } = useFunnelConfig(funnelConfig);

  if (!config) {
    return null;
  }

  return (
    <FunnelProvider resources={config}>
      <FlowProvider>
        {isRedesignFlow ? (
          <RedesignFlowScreens screenId={screenId} />
        ) : (
          <FlowScreens pageId={screenId} />
        )}
      </FlowProvider>
    </FunnelProvider>
  );
};
